import { render, staticRenderFns } from "./inputKemasanEmas.vue?vue&type=template&id=53916e86&"
import script from "./inputKemasanEmas.vue?vue&type=script&lang=js&"
export * from "./inputKemasanEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports